import { useEffect } from 'react'
import { useCookies } from 'react-cookie'

export const useLockSearch = (): [boolean, (updatedValue: boolean) => void] => {
  const [{ 'search-locked': lockCookie = 'false' }, setCookies] = useCookies(['search-locked'])

  const handleSetLocked = (locked: boolean) => {
    setCookies('search-locked', locked, { path: '/', expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 40) })
  }

  useEffect(() => {
    let locked = lockCookie === 'true'

    if (typeof window === 'undefined') locked = false
    if (!window.location.pathname.startsWith('/decks/')) locked = false

    const viewPortWidth = window.innerWidth

    // Small screens ignore this
    if (viewPortWidth <= 1000) locked = false

    handleSetLocked(locked)
  }, [])

  return [`${lockCookie}` === 'true', handleSetLocked]
}
